export default "__VITE_ASSET__CzNfDfAV__"